import { makeStyles } from '@mui/styles';

/** EatClub primary / highlight (buttons, spinners) */
export const TABLE_BRAND_YELLOW = '#FAD14C';

/** Padding for Table empty/loading body cells (Guest Manager + shared loading row) */
const emptyBodyCellShared = {
  borderBottom: 'none !important',
  padding: '16px 24px 18px',
  textAlign: 'left',
};

const useStyles = makeStyles(
  (theme) => ({
    tableContainer: {
      backgroundColor: 'white',
      borderRadius: '24px',
      boxShadow: '0px 4px 4px 0px #DADADA40',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      overflow: 'hidden',
    },
    tableOuter: {
      overflow: 'auto',
    },
    title: {
      padding: '6px 24px',
      minHeight: '64px',
      display: 'flex',
      alignItems: 'center',
    },
    searchContainer: {
      padding: '6px 24px',
      minHeight: '64px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
    },
    header: {
      display: 'inline-flex',
      gap: '6px',
      userSelect: 'none',
      alignItems: 'center',
      height: '100%',
      fontWeight: 500,
    },
    arrowIconHidden: { opacity: 0, transition: 'all 0.1s' },
    sortableHeader: {
      cursor: 'pointer',
      '&:hover': {
        color: theme.colors.smoke,
      },

      // Show arrow on hover
      '&:hover $arrowIconHidden': {
        opacity: '1 !important',
      },
    },
    arrowIcon: {},
    emptyData: {
      textAlign: 'center',
      fontSize: '14px',
      padding: '6px 16px',
    },
    emptyDataCustom: {
      ...emptyBodyCellShared,
      verticalAlign: 'top',
    },
    emptyDataLoading: {
      ...emptyBodyCellShared,
      verticalAlign: 'middle',
    },
    emptyStateEnter: {
      animation: '$fadeInEmptyState 240ms ease-out',
    },
    // Stable height between loading row and 2-line “Showing 0 guests” empty (avoids layout jump)
    emptyStateSlotBody: {
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: '64px',
      width: '100%',
    },
    loadingGuestsRow: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'row',
      gap: '12px',
      justifyContent: 'flex-start',
      width: '100%',
    },
    '@keyframes fadeInEmptyState': {
      from: { opacity: 0 },
      to: { opacity: 1 },
    },
    tdContents: {
      padding: '6px 16px',
    },
    row: {},
    clickableRow: {
      '&:hover': {
        cursor: 'pointer',
        backgroundColor: '#F5F5F5',
      },
    },
    table: {
      borderSpacing: 0,
      borderRadius: '24px',
      width: '100%',
      overflowX: 'auto',
      whiteSpace: 'nowrap',

      '& tbody td': {
        lineHeight: 2,
        minHeight: '36px',
      },

      '& tbody tr:not(:last-child) > td': {
        borderBottom: '1px solid #F2F2F2',
      },

      '& thead': {
        borderRadius: '24px',
      },
      '& th': {
        padding: '6px 16px',
        borderBottom: '1px solid #F2F2F2',
        backgroundColor: 'white',
        zIndex: '100',
        lineHeight: 2,
        fontWeight: 400,
        whiteSpace: 'nowrap',
        height: '56px',
        textAlign: 'left',
        fontSize: '14px',
      },

      '& ::-webkit-scrollbar': {
        '-webkit-appearance': 'none',
      },
      '& ::-webkit-scrollbar:vertical': {
        width: '12px',
      },
      '& ::-webkit-scrollbar:horizontal': {
        height: '12px',
      },
      '& ::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 0, 0, .25)',
        borderRadius: '10px',
        border: '2px solid #ffffff',
      },
      '& ::-webkit-scrollbar-track': {
        borderRadius: '10px',
        backgroundColor: '#ffffff',
      },
    },
    pagination: {
      display: 'flex',
      flexShrink: 0,
      gap: '8px',
      justifyContent: 'flex-end',
      alignItems: 'center',
      fontSize: '14px',
      borderTop: '1px solid #F2F2F2',
      height: '54px',
    },
    selectInput: {
      border: 0,
      cursor: 'pointer',
      fontSize: '14px',
    },
    footerButtons: {
      display: 'flex',
      gap: 0,
      marginRight: '12px',
    },
  }),
  { name: 'Table' },
);

export default useStyles;

export const paginationButtonStyles = {
  container: { display: 'flex', flexShrink: 0 },
  button: { padding: '8px', height: '40px', width: '40px' },
  disabled: { color: '#AAAAAA', backgroundColor: 'transparent', opacity: 0.2 },
};
